
























































import { Vue, Component, Prop } from "vue-property-decorator";
import { mapActions, mapState, mapGetters } from "vuex";
import { ROUTES_MAP } from "@/router";
import ProductCardInner from "@/components/ProductCardInner.vue";
import { isWishope } from "../common/utils";

const InlineCartProps = Vue.extend({
  inheritAttrs: false,
  computed: {
    ...mapState("global", ["cartOpen", "cart"]),
    ...mapGetters("vas", ["hasValidAddressAndShipping", "merchant"]),
  },
  methods: {
    ...mapActions("global", ["toggleCart"]),
    isWishope,

  },
});

@Component({
  components: {
    ProductCardInner,
  },
})
export default class InlineCart extends InlineCartProps {

  isGoToPaymentEnabled: boolean = false

  vcoConfig = {
    handler: this.closeCart,
    middleware(event: any) {
      if (
        event.target.id === "cart-toggle" ||
        document.getElementById("cart-toggle")?.contains(event.target)
      ) {
        return false;
      }
      return true;
    },
  };

  get emptyCart() {
    return (
      !this.cartList ||
      !this.cartList.products ||
      this.cartList.products.length === 0
    );
  }

  get currentViewIsProducts() {
    return this.$route.name === "PublicVAS__products";
  }

  get currentViewIsAddress() {
    return this.$route.name === "PublicVAS__address";
  }

  get cartTotalAmount() {
    return this.cart.products?.reduce((prev : number, curr : any) => {
      return prev + curr.requestedQuantity * curr.sellingPrice;
    }, 0);
  }

  get cartList() {
    /* variants grouped by parent

    let result = new Array();

    if (!this.cart) return [];

    const productsWithoutVariants = this.cart.products.filter( (p: any) => !p.parentProduct);
    result = result.concat(productsWithoutVariants);

    const productsWithVariants = this.cart.products.filter( (p: any) => p.parentProduct);


    const variantsGroupedByParentProductId = productsWithVariants.reduce((r: any, a: any) => {
      r[a.parentProduct.id] = r[a.parentProduct.id] || {}; //init object with key if not exists
      r[a.parentProduct.id].variants = r[a.parentProduct.id].variants || []; //init variants array if not exists
      r[a.parentProduct.id].variants.push(a);
      r[a.parentProduct.id].name = a.parentProduct.name;
      r[a.parentProduct.id].description = a.description;
      r[a.parentProduct.id].sellingPrice = (r[a.parentProduct.id].sellingPrice || 0) + a.sellingPrice;
      return r;
  }, {});

  Object.keys(variantsGroupedByParentProductId).forEach(key => {
    const product = variantsGroupedByParentProductId[key];
    result.push(product);
  })

  console.log(result);


    return {
      ...this.cart,
      products: result
    };
    */
    if (this.cart && this.cart.products) {
      this.cart.products = this.cart.products.map((p: any) => {
        const isVariant = !!p.parentProduct;
        if (isVariant) {
          p.variantName = p.name;
          p.name = p.parentProduct.name;
        }
        return p;
      });
    }

    return this.cart;
  }

  goToAddress() {
    this.toggleCart(false);
    this.$router.push({
      name: ROUTES_MAP.VAS_ADDRESS,
      params: this.$route.params,
    });
    //this.$router.push("address");
  }

  gotoPayment() {
    this.toggleCart(false);
    this.$root.$emit("submitAddress");
  }

  closeCart() {
    this.toggleCart(false);
  }

  created()
  {
    this.$root.$on("onShippingAddressFormValidChange", (isValid : boolean) => {
      this.isGoToPaymentEnabled = isValid
    });

  }
}
